export const LessonModule = {
    namespaced: true,

    state: {
        difficulties: [
            {
                id: 1,
                text: 'I found this lesson difficult'
            },
            {
                id: 2,
                text: 'I mastered this lesson'
            },
            {
                id: 3,
                text: 'I need more instruction on this lesson'
            },
        ],
        loading: false,
        selectedCourseFilter: 'All',
        focus_date_filter: new Date(),
    },

    mutations: {
        TOGGLE_LOADING(state, payload) {
            state.loading = payload
        },
    },

    actions: {
        sendSearch({commit}, payload) {
            commit('TOGGLE_LOADING', true)
        },
        set_focus_date({state}, date) {
            state.focus_date_filter = new Date(date)
        },
    }
};
